import React, { Fragment, useState } from 'react'
import { FlexContainer, TitleH5, HR, Button, capitalizeWords } from 'heliocor-ui'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux'
import 'styled-components/macro'

import { DocumentsList } from "../../../common"
import { WarningBox } from "../../../common"
import { DetailsWrapper, DragAndDropBox } from "./details.styles"
import { UploadDocument } from "../DocumentUpload/UploadDocument"
import { translateChecker } from "../../../utils/translateChecker"

function DocumentDetailsWithUpdate({
    document,
    documentConfig,
    deleteDocument,
    deleteIndividualDocument,
    canDelete = true,
    handleUpload,
    canUpload
}) {
    const { t } = useTranslation()
    const [modalIsOpen, openModal] = useState(false);
    const isRequest = useSelector((store) => store.config.isRequest);

    const proceedDeletion = () => {
        openModal(false);
        deleteDocument(documentType);
    };

    const documentType = document.type

    return (
        <FlexContainer>
            <DetailsWrapper responsive>
                <DragAndDropBox>
                    <UploadDocument
                        documentConfig={documentConfig}
                        handleUpload={handleUpload}
                        canUpload={canUpload}
                        margin={'0'}
                    />
                </DragAndDropBox>
                <FlexContainer column alignItems="flex-end">
                    <FlexContainer
                        column
                        margin="2rem 1rem"
                        maxWidth="18rem"
                        minWidth="18rem"
                    >
                        <FlexContainer justifyContent="space-between" alignItems="baseline">
                            <TitleH5 css="margin:.15rem;" value={t("docsUploaded")} />
                            {!isRequest && canDelete && (
                                <Button
                                    type="light"
                                    value={t("button.deleteAll")}
                                    onClick={() => openModal(true)}
                                />
                            )}
                        </FlexContainer>
                        <HR />
                        <DocumentsList
                            wrap
                            editable
                            data={document.datas}
                            docType={documentType}
                            keyToPrint="fileName"
                            handleDelete={deleteIndividualDocument}
                            docId={document.identifier}
                            canDelete={canDelete}
                        />
                    </FlexContainer>
                </FlexContainer>
            </DetailsWrapper>
            <WarningBox
                content={
                    <Fragment>
                        {t("warning.deleteDoc")}
                        <p css="text-align: center;">
                            <i>{capitalizeWords(translateChecker(document.type))}</i>
                        </p>
                    </Fragment>
                }
                onClose={() => openModal(false)}
                open={modalIsOpen}
                buttons={[
                    {
                        type: "default",
                        onClick: proceedDeletion,
                        value: t("button.continue"),
                        autoFocus: true,
                    },
                    {
                        type: "light",
                        margin: "0 1rem",
                        onClick: () => openModal(false),
                        value: t("button.cancel"),
                    },
                ]}
            />
        </FlexContainer>
    );
}

export { DocumentDetailsWithUpdate }
